import { IActionFn } from '@/store/types';
import { IListRecord, IModuleState } from './types';
import { $http } from '@/axios';
import download from 'downloadjs';
import store from '@/store';

// 查询 oss 文件列表
export const queryOssFiles: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const params = { tagBucket: 'asset', path: `CustomResources/${payload}` };
    commit('setOssFiles', { ...state.files, loading: true });
    const res: IListRecord[] = await $http.post('/v1/baseinfo/oss/filelist', params);
    const data = res.filter((item) => !(item.size === 0 && item.pathName === ''));
    commit('setOssFiles', { data });
  } catch (e) {
    commit('setOssFiles', { data: [] });
  }
};

// oss 验证信息接口
export const queryOssPolicy: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { path, ...rest } = payload;
    const params = { domain: 'asset', tag: Date.now(), path: `CustomResources/${path}`, ...rest };
    commit('setOssPolicy', { data: null, loading: true });
    const res = await $http.post('/v1/baseinfo/oss/getpolicy', params);
    commit('setOssPolicy', { data: res });
  } catch (e) {
    store.commit('common/setToast', { visible: true, text: 'OSS 验证失败' });
  }
};

// 复制 oss 文件
export const copyOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/oss/copyfile', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除 oss 文件
export const deleteOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const params = { tagBucket: 'asset', tagFile: `CustomResources/${payload}` };
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/oss/deletefile', params);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 下载 oss 文件
export const downloadOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  const i = payload.lastIndexOf('/');
  const filename = payload.slice(i + 1);
  commit('setLoading', true);
  const res: string = await $http.post('/v1/baseinfo/oss/fileurl', { tagFile: `CustomResources/${payload}` });
  const xhr = new XMLHttpRequest();
  xhr.open('GET', res, true);
  xhr.responseType = 'blob';
  xhr.onload = () => {
    download(xhr.response, filename);
    commit('setLoading', false);
  };
  xhr.onerror = () => {
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '下载失败' });
  };
  xhr.send();
};

// 临时上传 oss 文件（通过服务器中转上传）
export const uploadOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { path, ...rest } = payload;
    const params = { bucket: 'asset', path: `CustomResources/${path}`, ...rest };
    commit('setLoading', true);
    await $http.post('/v1/baseinfo/oss/addfile', params);
  } finally {
    commit('setLoading', false);
  }
};
